/* eslint-disable */
export const AGREEMENT = `
<h4>您只有接受以下所有服条款，才能继续申请：</h4>

<h4>1、服务条款的确认和接纳</h4>
<p>同花顺服务（以下简称同花顺）的所有权和运作权归核新软件技术有限公司（以下简称核新公司）所有，包括但不限于行情软件、委托交易系统、网站、手机短信服务等。所提供的服务必须按照核新公司章程，服务条款和操
作规则严格执行。用户完成注册程序即表示用户与核新公司达成协议并接受所有的服务条款。</p>

<h4>2、服务简介</h4>
<p>核新公司运用自己的服务系统通过互联网络为用户提供各项服务。用户必须：</p>
<p>支付个人上网和与此服务有关的费用。</p>
<p>考虑到同花顺产品服务的重要性，用户同意：</p>
<p>（1）提供及时、详尽及准确的个人资料。</p>
<p>（2）不断更新注册资料，符合及时、详尽准确的要求。所有原始键入的资料将引用为注册资料。</p>
<p>用户主动填写的注册信息为浙江核新同花顺网络信息股份有限公司及其子公司所有，浙江核新同花顺网络信息股份有限公司及其子公司可据此为用户提供服务。另外，用户可授权浙江核新同花顺网络信息股份有限公司及其子
公司向其他公司透露其注册资料，否则核新公司及其子公司不能公开用户的姓名、住址、电子邮箱、帐号。除非：</p>
<p>（1）用户要求核新公司通过电子邮件服务透露这些信息。</p>
<p>（2）相应的法律、法规要求及程序服务需要核新公司提供用户的个人资料。</p>
<p>如果用户提供的资料不准确，不真实，不合法有效，核新公司保留结束用户使用同花顺各项服务的权利。</p>
<h4>3、服务条款的修改</h4>
<p>核新公司会在必要时修改服务条款，服务条款一旦发生变动，核新公司将会在用户进入下一步使用前的页面提示修改内容。如果您同意改动，则再一次激活"我同意"按钮。如果您不接受，则及时取消您的用户使用服务资格
。</p>
<p>用户要继续使用同花顺各项服务需要两方面的确认：</p>
<p>（1）首先确认服务条款及其变动。</p>
<p>（2）同意接受所有的服务条款限制。</p>

<h4>4、服务修订</h4>
<p>核新公司保留随时修改或中断服务而不需通知用户的权利。用户接受核新公司行使修改或中断服务的权利，核新公司不需对用户或第三方负责。</p>

<h4>5、用户隐私制度</h4>
<p>尊重用户个人隐私是核新公司的一项基本政策。所以，作为对以上第二点个人注册资料分析的补充，核新公司一定不会公开、编辑或透露用户的注册资料及保存在同花顺各项服务中的非公开内容，除非核新公司在诚信的基础
上认为透露这些信息在以下几种情况是必要的：</p>
<p>（1）遵守有关法律规定，包括在国家有关机关查询时，提供用户在同花顺的网页上发布的信息内容及其发布时间、互联网地址或者域名。</p>
<p>（2）遵从核新公司产品服务程序。</p>
<p>（3）保持维护核新公司的商标所有权。</p>
<p>（4）在紧急情况下竭力维护用户个人和社会大众的隐私安全。</p>
<p>（5）根据第10条的规定或者核新公司认为必要的其他情况下。</p>

<p>用户在此授权核新公司可以向其电子邮箱发送商业信息并同意向其预留的电话号码拨打回访电话。用户在享用同花顺各项服务的同时，同意接收同花顺发出的各类信息。</p>
<h4>6、用户的帐号、密码和安全性</h4>
<p>您一旦注册成功成为用户，您将得到一个密码和帐号。如果您未保管好自己的帐号和密码而对您、核新公司或第三方造成的损害，您将负全部责任。另外，每个用户都要对其帐户中的所有活动和事件负全责。您可随时改变您
的密码，也可以结束旧的帐户重开一个新帐户。用户同意若发现任何非法使用用户帐号或安全漏洞的情况，立即通告核新公司。</p>

<h4>7、拒绝提供担保</h4>
<p>用户明确同意服务的使用由用户个人承担风险。核新公司明确表示不提供任何类型的担保，不论是明确的或隐含的，但是对商业性的隐含担保，特定目的和不违反规定的适当担保除外。核新公司不担保服务一定能满足用户的
要求，也不担保服务不会受中断，对服务的及时性、安全性、出错发生都不作担保。核新公司拒绝提供任何担保，包括信息能否准确、及时、顺利地传送。用户理解并接受下载或通过核新公司产品服务取得的任何信息资料取决于
用户自己，并由其承担系统受损或资料丢失的所有风险和责任。核新公司对在同花顺上得到的任何商品购物服务或交易进程，都不作担保。用户不会从核新公司收到口头或书面的意见或信息，核新公司也不会在这里作明确担保。</p>

<h4>8、有限责任</h4>
<p>核新公司对直接、间接、偶然、特殊及继起的损害不负责任，这些损害来自：不正当使用产品服务，在网上购买商品或类似服务，在网上进行交易，非法使用服务或用户传送的信息有所变动。这些损害会导致核新公司形象受
损，所以核新公司早已提出这种损害的可能性。</p>

<h4>9、同花顺信息的储存及限制</h4>
<p>核新公司不对用户所发布信息的删除或储存失败负责。核新公司保留判定用户的行为是否符合同花顺服务条款的要求和精神的权利，如果用户违背了服务条款的规定，则中断其同花顺服务的帐号。同花顺所有的文章版权归原
文作者和核新公司共同所有，任何人需要转载同花顺的文章，必须征得原文作者和核新公司授权。</p>

<h4>10、用户管理</h4>
<p>用户单独承担发布内容的责任。用户对服务的使用是根据所有适用于服务的地方法律、国家法律和国际法律标准的。用户承诺：</p>
<p>（1）在同花顺的网页上发布信息或者利用同花顺的服务时必须符合中国有关法规(部分法规请见附录)，不得在同花顺的网页上或者利用同花顺的服务制作、复制、发布、传播以下信息：</p>
    <p class="sub">(a) 反对宪法所确定的基本原则的；</p>
    <p class="sub">(b) 危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</p>
    <p class="sub">(c) 损害国家荣誉和利益的；</p>
    <p class="sub">(d) 煽动民族仇恨、民族歧视，破坏民族团结的；</p>
    <p class="sub">(e) 破坏国家宗教政策，宣扬邪教和封建迷信的；</p>
    <p class="sub">(f) 散布谣言，扰乱社会秩序，破坏社会稳定的；</p>
    <p class="sub">(g) 散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</p>
    <p class="sub">(h) 侮辱或者诽谤他人，侵害他人合法权益的；</p>
    <p class="sub">(i) 含有法律、行政法规禁止的其他内容的。</p>
<p>（2）在同花顺的网页上发布信息或者利用同花顺的服务时还必须符合其他有关国家和地区的法律规定以及国际法的有关规定。</p>
<p>（3）不利用同花顺的服务从事以下活动：</p>
    <p class="sub">(a) 未经允许，进入计算机信息网络或者使用计算机信息网络资源的；</p>
    <p class="sub">(b) 未经允许，对计算机信息网络功能进行删除、修改或者增加的；</p>
    <p class="sub">(c) 未经允许，对进入计算机信息网络中存储、处理或者传输的数据和应用程序进行删除、修改或者增加的；</p>
    <p class="sub">(d) 故意制作、传播计算机病毒等破坏性程序的；</p>
    <p class="sub">(e) 其他危害计算机信息网络安全的行为。</p>
<p>（4）不以任何方式干扰同花顺的服务。</p>
<p>（5）遵守同花顺的所有其他规定和程序。</p>
<p>用户需对自己在使用同花顺服务过程中的行为承担法律责任。用户理解，如果同花顺发现其网站传输的信息明显属于上段第(1)条所列内容之一，依据中国法律，核新公司有义务立即停止传输，保存有关记录，向国家有关
机关报告，并且删除含有该内容的地址、目录或关闭服务器。</p>
<p>用户使用同花顺电子公告服务，包括电子布告牌、电子白板、电子论坛、网络聊天室和留言板等以交互形式为上网用户提供信息发布条件的行为，也须遵守本条的规定以及同花顺将专门发布的电子公告服务规则，上段中描述
的法律后果和法律责任同样适用于电子公告服务的用户。</p>
<p>若用户的行为不符合以上提到的服务条款，核新公司将作出独立判断立即取消用户服务帐号。</p>

<h4>11、保障</h4>
<p>用户同意保障和维护核新公司全体成员的利益，负责支付由用户使用超出服务范围引起的律师费用，违反服务条款的损害补偿费用，其它人使用用户的电脑、帐号和其它知识产权的追索费。</p>

<h4>12、结束服务</h4>
<p>用户或核新公司可随时根据实际情况中断服务。核新公司不需对任何个人或第三方负责而随时中断服务。用户若反对任何服务条款的建议或对后来的条款修改有异议，或对同花顺的服务不满，用户只有以下的追索权：</p>
  <p>（1）不再使用同花顺服务。</p>
  <p>（2）结束用户使用同花顺服务的资格。</p>
  <p>（3）通告核新公司停止该用户的服务。</p>
　<p>结束用户服务后，用户使用同花顺服务的权利马上中止。从那时起，核新公司不再对用户承担任何义务。</p>

<h4>13、通告</h4>
<p>所有发给用户的通告都可通过电子邮件或常规的信件传送。核新公司会通过邮件服务发报消息给用户，告诉他们服务条款的修改、服务变更、或其它重要事情。</p>

<h4>14、参与广告策划</h4>
<p>在核新公司许可下用户可在他们发表的信息中加入宣传资料或参与广告策划，在同花顺各项免费服务上展示他们的产品。任何这类促销方法，包括运输货物、付款、服务、商业条件、担保及与广告有关的描述都只是在相应的
用户和广告销售商之间发生。核新公司不承担任何责任，核新公司没有义务为这类广告销售负任何一部分的责任。</p>

<h4>15、内容的所有权</h4>
<p>内容的定义包括：文字、软件、声音、相片、录象、图表；在广告中的全部内容；同花顺服务为用户提供的商业信息。所有这些内容均受版权、商标、标签和其它财产所有权法律的保护。所以，用户只能在核新公司和广告商
授权下才能使用这些内容，而不能擅自复制、再造这些内容、或创造与内容有关的派生产品。</p>

<h4>16、法律</h4>
<p>用户和核新公司一致同意有关本协议以及使用同花顺的服务产生的争议交由仲裁解决，但是核新公司有权选择采取诉讼方式，并有权选择受理该诉讼的有管辖权的法院。若有任何服务条款与法律相抵触，那这些条款将按尽可
能接近的方法重新解析，而其它条款则保持对用户产生法律效力和影响。</p>

<h4>17、同花顺所含服务的信息储存及安全</h4>
<p>核新公司对同花顺服务将尽力维护其安全性及方便性，但对服务中出现信息删除或储存失败不承担任何负责。另外我们保留判定用户的行为是否符合同花顺服务条款的要求的权利，如果用户违背了服务条款的规定，将会中断
其服务的帐号。</p>

<p>附：</p>
<p>中华人民共和国电信条例</p>
<p>互联网信息服务管理办法</p>
<p>互联网电子公告服务管理规定</p>
<p>中华人民共和国计算机信息网络国际联网管理暂行规定</p>
<p>中华人民共和国计算机信息网络国际联网管理暂行规定实施办法</p>
<p>中华人民共和国计算机信息系统安全保护条例</p>
<p>计算机信息网络国际联网安全保护管理办法</p>`;